import { MenuItem, Select, SelectChangeEvent, SelectProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CatalogProductType } from '../enums'

export interface CatalogProductTypeSelectProps extends Omit<
  SelectProps<CatalogProductType | ''>,
  'value' | 'onChange' | 'multiple'
> {
  value: CatalogProductType | ''
  onChange: (type: CatalogProductType) => void
}

export default function CatalogProductTypeSelect({
  value,
  onChange,
  ...props
}: CatalogProductTypeSelectProps) {
  const { t } = useTranslation('catalogProduct')

  function handleChange(event: SelectChangeEvent<CatalogProductType | ''>) {
    onChange(event.target.value as CatalogProductType)
  }

  return (
    <Select value={value} onChange={handleChange} {...props}>
      <MenuItem value={CatalogProductType.ELECTRICAL_CABINET}>{t('electricalCabinet')}</MenuItem>
      <MenuItem value={CatalogProductType.HEATER}>{t('heater')}</MenuItem>
      <MenuItem value={CatalogProductType.GENERATOR}>{t('generator')}</MenuItem>
      <MenuItem value={CatalogProductType.AXIOMA_W1}>{t('axiomaW1')}</MenuItem>
      <MenuItem value={CatalogProductType.SPINE_MODULE}>{t('spineModule')}</MenuItem>
      <MenuItem value={CatalogProductType.SPINE_MULTI_MEASUREMENT}>
        {t('spineMultiMeasurement')}
      </MenuItem>
      <MenuItem value={CatalogProductType.VALVE}>{t('spineValve')}</MenuItem>
      <MenuItem value={CatalogProductType.SPINE_LOAD}>{t('spineLoad')}</MenuItem>
      <MenuItem value={CatalogProductType.AURORA}>{t('aurora')}</MenuItem>
      <MenuItem value={CatalogProductType.RUUVI_TAG}>{t('ruuviTag')}</MenuItem>
    </Select>
  )
}
